// C.1 — стаб для Расчёта (бывший юнит Глобала). В v6 ID может быть другим;
// пока no-op чтобы не падали импорты в phases.js. Возвращает пустой массив
// «выстрелов» (phases.js итерирует по нему).

export function raschetOnAllyAttacked(_state, _attackerIdx, _attacker, _enemyIdx, _target) {
  return [];
}
